<template>
  <footer class="page-footer">
    <div class="copyright">
      <span>© SamKnows Ltd {{ year }}</span>
      |
      <span>
        <a
          href="https://www.samknows.com/privacy-policy"
          target="_blank"
          aria-label="Privacy Policy"
        >
          {{ $t('common.linkPrivacy') }}
        </a>
      </span>
    </div>

    <div class="social">
      <ul>
        <li>
          <a
            href="https://samknows.com/"
            target="_blank"
            aria-label="Samknows.com"
          >
            <img class="page-footer__icon" src="/img/samknows-square.svg" />
          </a>
        </li>
        <li>
          <a
            href="https://www.facebook.com/SamKnowsLimited/?fref=ts"
            target="_blank"
            aria-label="Facebook"
          >
            <SvgIcon name="logo-facebook" />
          </a>
        </li>
        <li>
          <a
            href="https://twitter.com/samknows"
            target="_blank"
            aria-label="Twitter"
          >
            <SvgIcon name="logo-twitter" />
          </a>
        </li>
        <li>
          <a
            href="https://www.linkedin.com/company/samknows-limited"
            target="_blank"
            aria-label="LinkedIn"
          >
            <SvgIcon name="logo-linkedin" />
          </a>
        </li>
      </ul>
    </div>

    <div class="print-legal-notice">
      <p>
        All information in this document is protected by copyright. Except as
        set out below no part of this document may be reproduced in any form or
        by any means without prior written permission from SamKnows. No right to
        modify, distribute, publish, transmit or create derivative works of any
        information in this document is permitted for any public or commercial
        purposes and nothing contained in this document shall be construed as
        conferring any licence or right under any patent, trademark or copyright
        of SamKnows or any third party.
      </p>
      <p>
        SamKnows authorises you to copy this document solely for non-commercial
        use within your company in support of SamKnows services and products. No
        other use of the information is authorised. In consideration of this
        authorisation, you agree that any copy of this document which you make,
        in whole or in part, shall retain all copyright and other proprietary
        notices in the same form and manner as on the original.
      </p>
    </div>
  </footer>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { SvgIcon } from '@te/cdev-design-system';

export default defineComponent({
  components: {
    SvgIcon
  },
  data: () => ({
    year: new Date().getFullYear()
  })
});
</script>

<style lang="scss" scoped>
.page-footer {
  padding: 11px $container-spacing;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  width: 100%;
  background: color(base-background);
  border-top: 1px solid color(lines);
  min-height: 65px;

  &__icon {
    width: 15px;
    height: 15px;
  }

  @include breakpoint(small) {
    align-items: center;
    flex-direction: row;
  }

  @include breakpoint(extra-small) {
    padding: 11px $container-spacing-mobile;
  }
}

.social {
  @include breakpoint(small) {
    display: flex;
    align-items: center;
  }

  ul {
    display: flex;

    margin: 0;
    padding: 0;

    list-style: none;
  }

  li {
    padding: 0 5px;
  }
}

.copyright {
  padding-bottom: 10px;

  @include breakpoint(small) {
    padding: 0;
  }

  span {
    padding: 0 5px;
  }
}

.print-legal-notice {
  display: none;

  opacity: 0.66;
}
</style>
